import React, { useState } from 'react';
import { useMatch, useLocation } from '@reach/router';
import Page from 'components/Page';
import SEO from 'components/SEO';
import { PageProps, IBlog } from 'types';
import BlogHeader from 'sections/blogPost/BlogHeader';
import BlogContent from 'sections/blogPost/BlogContent';
import BlogComments from 'sections/blogPost/BlogComments';
import Subscribe from 'sections/blogPost/Subscribe';
import { fetchData, getDataUrls } from 'data/blog-post';
import { DynamicContentView, useDynamicContent } from 'components/dynamic-content';

const StaticBlogPost: React.FunctionComponent<PageProps<IBlog>> = ({ pageContext }) => {
  const match = useMatch('/blog/:slug');
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const dataUrls = getDataUrls(match?.slug || '', params.get('status') === 'draft' ? 'draft' : 'published');
  const getData = (): Promise<IBlog> =>
    fetchData(match?.slug || '', params.get('status') === 'draft' ? 'draft' : 'published');
  const { data, loading } = useDynamicContent<IBlog>(getData, pageContext.data);
  const [showDiscourse] = useState<boolean>(data?.status !== 'draft');
  const ogImage = data && data.opengraph_image?.length > 0 ? data?.opengraph_image[0].url : undefined;
  const articleTags = data
    ? data.blog_tags.map((tag) => ({
        name: 'article:tag',
        content: tag.name
      }))
    : [];

  return (
    <Page type="blog-post">
      <SEO
        title={data?.title || ''}
        description={data?.abstract || ''}
        ogImage={ogImage}
        ogType="article"
        canonical={location.pathname}
        meta={[{ name: 'article:published_time', content: data?.published_at || '' }, ...articleTags]}
      >
        {/* <script type="application/ld+json">
          {`{
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            "headline": "${data?.title || ''}",
            "image": "${ogImage || ''}",
            "datePublished": "${data?.published_at || ''}",
            "dateModified": "${data?.updated_at || ''}"
          }`}
        </script> */}
      </SEO>
      <DynamicContentView loading={loading} dataUrls={dataUrls}>
        <article itemScope itemType="https://schema.org/BlogPosting" itemProp="mainEntity">
          <BlogHeader blogPost={data} />
          <BlogContent content={data?.content} />
        </article>
        {/* {data.strapiBlog && <BlogAuthor author={data.strapiBlog.author} />} */}
        {process.env.GATSBY_DISCOURSE_ENABLED === 'true' && showDiscourse && <BlogComments slug={pageContext.slug} />}
        <Subscribe />
      </DynamicContentView>
    </Page>
  );
};

export default StaticBlogPost;
